import React, { useState, useRef, useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import People from '@src/pc/index/layout/Page1/People';
import Chip from 'Chip';

const Page1 = (props) => {
    const { peopleList, leaderVideo, onChangeMaskVisible, onChangeCurrentVideo, onChangeFloat, config, peopleIndex, onChangePeopleIndex } = props;
    const [isShowHUD, setIsShowHUD] = useState(false);

    const swiperRef = useRef();
    const maskRef = useRef();
    const lightRef = useRef();

    const changePeopleAndSwiper = (index) => {
        onChangePeopleIndex(index);
    };

    useLayoutEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        swiperRef.current?.slideTo(peopleIndex + 1);
    }, [peopleIndex]);

    const toPrev = () => {
        changePeopleAndSwiper(peopleIndex - 1);
    };

    const toNext = () => {
        if (peopleIndex < peopleList.length - 1) {
            changePeopleAndSwiper(peopleIndex + 1);
        }
    };

    const openVideo = () => {
        onChangeCurrentVideo({
            url: leaderVideo.videoUrl,
            guid: leaderVideo.videoGuid,
            duration: leaderVideo.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    const ChangeAnimate = useCallback((node) => {
        if (node) {
            setTimeout(() => {
                node.classList.add(Style.part2);
                setTimeout(() => {
                    setIsShowHUD(true);
                    onChangeFloat(true);
                    node.classList.add(Style.part3);
                    maskRef.current.classList.add(Style.part3_mask);
                    setTimeout(() => {
                        lightRef.current.classList.add(Style.lightShow);
                        setTimeout(() => {
                            changePeopleAndSwiper(0);
                        }, 1000);
                    }, 600);
                }, 800);
            }, 1020);
        }
    }, []);

    return (
        <div className={Style.page1}>
            {peopleIndex === -1 && <img className={`${Style.logo} ${isShowHUD ? Style.show : ''}`} src={require('@src/common/assets/logo.png')} alt="" />}
            {config.find((a) => a.id === 'peopleList').isShow && (
                <div className={`${Style.peopleList} ${isShowHUD ? Style.show : ''} ${peopleIndex < 0 ? '' : Style.inPeople}`}>
                    <div className={Style.first}>
                        <div className={`${Style.people} ${-1 === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(-1)}>
                            首页
                        </div>
                        <span className={Style.divider}>/</span>
                    </div>
                    {peopleList.map((people, index) => {
                        return (
                            <div key={index}>
                                <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(index)}>
                                    {people.name}
                                </div>
                                {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                            </div>
                        );
                    })}
                </div>
            )}
            <Swiper
                modules={[Navigation, Mousewheel, Keyboard]}
                className={Style.swiper}
                speed={1500}
                mousewheel={{
                    forceToAxis: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => onChangePeopleIndex(swiper.realIndex - 1)}>
                <SwiperSlide>
                    <div style={{ position: 'relative', height: '100%' }}>
                        <div className={Style.mask} ref={maskRef} />
                        <video autoPlay muted loop preload="auto" src="https://x0.ifengimg.com/fe/custom/2022_08_26/junpintan_video.mp4" className={Style.video} />
                        <div ref={ChangeAnimate} className={`${Style.junpintanLogo} ${Style.part1}`}>
                            <img className={Style.junpintan} src={require('@src/common/assets/junpintan.png')} alt="" />
                            <div className={Style.lightWp}>
                                <img className={Style.light} ref={lightRef} src={require('@src/common/assets/light.png')} alt="" />
                            </div>
                        </div>

                        <Chip id="260447" type="struct" name="leaderVideo" title="先导片" groupName="先导片">
                            <div className={`${Style.playWp} ${isShowHUD ? Style.show : ''}`} onClick={openVideo}>
                                <img className={Style.boat} src={require('@src/common/assets/boat.gif')} alt="" />
                                <div className={Style.play}>
                                    <img className={Style.play} src={require('@src/common/assets/play_main.png')} alt="" />
                                    <span>先导片</span>
                                </div>
                            </div>
                        </Chip>
                    </div>
                </SwiperSlide>
                {config.find((a) => a.id === 'peopleList').isShow &&
                    peopleList.map((people, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <People people={people} onChangeMaskVisible={onChangeMaskVisible} onChangeCurrentVideo={onChangeCurrentVideo} />
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
            {config.find((a) => a.id === 'peopleList').isShow && isShowHUD && (
                <>
                    <img
                        className={`${Style.navigation} ${Style.prev} ${peopleIndex > -1 ? '' : Style.hide}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'prev' : 'prev2'}.png`)}
                        alt=""
                        onClick={toPrev}
                    />
                    <img
                        className={`${Style.navigation} ${Style.next} ${peopleIndex === -1 ? Style.animate : ''}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'next' : 'next2'}.png`)}
                        alt=""
                        onClick={toNext}
                    />
                </>
            )}
        </div>
    );
};

Page1.propTypes = {
    peopleList: PropTypes.array,
    config: PropTypes.array,
    leaderVideo: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    onChangeFloat: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page1);
